// ===========================================================================
// Language names for the tags that travel with a match.
//
// A person's language hint is a BCP-47 tag ("es", "pt-br"); the chat header
// says "prefers Spanish", not "prefers es". The list is the set of languages
// Lumi's translation packs and standing rooms speak of, in English -- the UI
// language -- and anything else falls back to the tag itself rather than to
// silence, so an unlisted language is still shown. ASCII only.
// ===========================================================================

const NAMES = Object.freeze({
  en: 'English',
  es: 'Spanish',
  fr: 'French',
  de: 'German',
  pt: 'Portuguese',
  it: 'Italian',
  nl: 'Dutch',
  pl: 'Polish',
  tr: 'Turkish',
  ar: 'Arabic',
  hi: 'Hindi',
  ja: 'Japanese',
  ko: 'Korean',
  zh: 'Chinese',
  ru: 'Russian',
});

/**
 * The English name of a language tag, or the tag itself when it is not one of
 * the known two-letter codes. A region subtag is ignored for the lookup
 * ("pt-BR" is Portuguese); an empty or non-string tag gives ''.
 *
 * @param {string} tag
 * @returns {string}
 */
export function languageName(tag) {
  if (typeof tag !== 'string') return '';
  const trimmed = tag.trim();
  if (!trimmed) return '';
  const primary = trimmed.split(/[-_]/)[0].toLowerCase();
  return NAMES[primary] || trimmed;
}

export default { languageName };
